import { render, staticRenderFns } from "./nft-settings.vue?vue&type=template&id=51296efe&"
import script from "./nft-settings.vue?vue&type=script&lang=js&"
export * from "./nft-settings.vue?vue&type=script&lang=js&"
import style0 from "./nft-settings.vue?vue&type=style&index=0&id=51296efe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports